import { SIZE_DESCREPANCY } from "@/intergrations/constants";

export function getQuerySizeInBytes(query: string) {  
  const encodedQuery = query.toString();
  const calcEstimatedByteSize = Math.floor(Buffer.from(encodedQuery).length);
  const byteSize = calcEstimatedByteSize + SIZE_DESCREPANCY; 
  return byteSize;
}